<template>
  <div class="goodsTable">
    <!-- 运输载具数据表格 -->
    <vxe-toolbar v-if="$route.query.isEdit == 'Y'">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('acceptanceDetail.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('acceptanceDetail.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="goodsData"
      :columns="columnList"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      highlight-current-row
      @current-change="currentChange"
      :edit-rules="goodsTableEditRules"
      auto-resize
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <collectionInfo ref="collectionInfo" :detail="detail"> </collectionInfo>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import collectionInfo from './collectionInfo';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  // import MASTER_API from '@/api/masterData/company.js';
  // import { resolve, reject } from 'q';
  // import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'returnAdd',
    components: {
      collectionInfo,
      // SearchTable,
      // InputNumber,
    },
    props: {
      exportChildDataDelayLock: {
        type: Function,
        default: null,
      },
      baseData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        activeAccept: { id: null, tempId: null }, //当前编辑的承兑行
        acceptanceInfo: { delayPaymentType: '0' }, //承兑信息
        goodsData: [],
        editConfig: {
          trigger: 'click',
          mode: 'row',
          showStatus: true,
          activeMethod: this.activeRowMethod,
        },
        ladingNoLoading: false,
        ladingNoOptions: [], //提货仓库下拉数据
        departmentOptions: [],
        activeIndex: null,
        detail: [],
        delDelayPayList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('financeSalesInvoiceDetail.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.delayAmount'),
            field: 'delayAmount',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.delayAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['delayAmount']}
                    placeholder={this.$t(
                      'tFundCreditLetterLockExchangeRate.placeholder.delayAmount'
                    )}
                    clearable={true}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'delayAmount')}
                  ></input-number>,
                ];
              },
            },
          }, //押汇金额
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.delayExchangeRate'),
            field: 'delayExchangeRate',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.delayExchangeRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['delayExchangeRate']}
                    placeholder={this.$t(
                      'tFundCreditLetterLockExchangeRate.placeholder.delayExchangeRate'
                    )}
                    clearable={true}
                    precision={this.$globalVar.ePoint}
                    max={9999999999}
                    onInput={(val) => this.updateCol(row, val, 'delayExchangeRate')}
                  ></input-number>,
                ];
              },
            },
          }, //押汇利率
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.delayCost'),
            field: 'delayCost',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.calCol(row, 'delayCost')}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['delayCost']}
                    placeholder={this.$t('tFundCreditLetterLockExchangeRate.placeholder.delayCost')}
                    clearable={true}
                    max={99999999999}
                    onInput={(val) => this.updateCol(row, val, 'delayCost')}
                  ></input-number>,
                ];
              },
            },
          }, //押汇费用
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.delayDate'),
            field: 'delayDate',
            width: 200,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'date',
                format: 'yyyy/MM/dd',
                valueFormat: 'yyyy-MM-dd',
              },
              events: {
                change: (obj) => this.updateCol(obj.row, obj.row['delayDate'], 'delayDate'),
              },
            },
          }, //押汇日期
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.delayPaymentDate'),
            field: 'delayPaymentDate',
            width: 200,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'date',
                format: 'yyyy/MM/dd',
                valueFormat: 'yyyy-MM-dd',
              },
              events: {
                change: (obj) =>
                  this.updateCol(obj.row, obj.row['delayPaymentDate'], 'delayPaymentDate'),
              },
            },
          }, //押汇到期日
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.bankAccountNum'),
            field: 'bankAccountNum',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.bankAccountNum}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bankAccount"
                    isMultiple={true}
                    currentValue={row['bankAccountNum']}
                    checkRowKeys={[row['bankAccountNum']]}
                    extraData={{ companyCode: this.baseData.businessCompanyCode }}
                    onInput={(val) => this.updateCol(row, val, 'bankAccountNum')}
                  ></search-table>,
                ];
              },
            },
          }, //押汇银行账户号码
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.businessDepartmentCode'),
            field: 'businessDepartmentCode',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.businessDepartmentName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="companyDept"
                    isMultiple={true}
                    currentValue={row['businessDepartmentName']}
                    checkRowKeys={[row['businessDepartmentCode']]}
                    extraData={{ belongCompanyCode: this.baseData.businessCompanyCode }}
                    onInput={(val) => this.updateCol(row, val, 'businessDepartmentCode')}
                  ></search-table>,
                ];
              },
            },
          }, //业务部门编码收证业务部门编码
          {
            title: this.$t('tFundCreditLetterDelayPayment.column.isLockExchangeRate'),
            field: 'delayPaymentType',
            width: 200,
          }, //押汇状态
        ];
      },
      goodsTableEditRules() {
        return {
          delayAmount: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.delayAmount'),
            },
          ],
          delayExchangeRate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.delayExchangeRate'),
            },
          ],
          delayCost: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.delayCost'),
            },
          ],
          delayDate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.delayDate'),
            },
          ],
          delayPaymentDate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.delayPaymentDate'),
            },
          ],
          businessDepartmentName: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.businessDepartmentName'),
            },
          ],
          isLockExchangeRate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.isLockExchangeRate'),
            },
          ],
          branchName: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.branchName'),
            },
          ],
          bankAccountNum: [
            {
              required: true,
              message: this.$t('acceptanceDetail.delayPaymentTable.bankAccountNum'),
            },
          ],
          businessDepartmentCode: [
            {
              required: true,
              message: this.$t('tFundCreditLetterDelayPayment.column.businessDepartmentCode'),
            },
          ],
        };
      },
    },
    mounted() {},
    methods: {
      //JSX更新字段
      updateCol(row, val, type) {
        console.log(row, val, type);
        row[type] = val;
        if (type == 'bankAccountNum') {
          row.bankAccountNum = val[0].bankAccountNum;
          row.bankAccountName = val[0].bankAccountName;
          row.branchCode = val[0].branchCode;
          row.branchName = val[0].branchName;
        } else if (type == 'businessDepartmentCode') {
          row['businessDepartmentCode'] = val[0].createDepartmentCode;
          row['businessDepartmentName'] = val[0].createDepartmentName;
        } else if (
          ['delayAmount', 'delayExchangeRate', 'delayPaymentDate', 'delayDate'].indexOf(type) != -1
        ) {
          this.calCol(row, 'delayCost');
          if (type == 'delayAmount') this.$refs.goodsTable.updateFooter();
        } else if (type == 'delayPaymentType') {
          console.log('1111111');
        }
      },
      // 列属性含有计算公式
      calCol(row, type) {
        //默认：押汇费用=押汇金额*押汇利率*（押汇到期日-押汇日期）/360，允许手工修改
        if (
          type == 'delayCost' &&
          row['delayDate'] &&
          row['delayPaymentDate'] &&
          row['delayAmount'] &&
          row['delayExchangeRate']
        ) {
          //（押汇到期日-押汇日期）
          let dateDiff = XEUtils.getDateDiff(row['delayDate'], row['delayPaymentDate']);
          if (!dateDiff.done) {
            this.$message({
              showClose: true,
              message: '押汇到期日需大于押汇日期',
              type: 'error',
            });
            row['delayPaymentDate'] = row['delayDate'];
            return;
          }
          dateDiff = dateDiff.time / 1000 / 60 / 60 / 24;
          let delayExchangeRate = this.$cal.calCommon(row['delayExchangeRate'], 100, '/');
          // 保留2位小数
          row[type] = this.$cal.calCommon(
            this.$cal.calCommon(
              this.$cal.calCommon(row['delayAmount'], delayExchangeRate, '*'),
              dateDiff,
              '*'
            ),
            360,
            '/',
            'amount'
          );
        }
        return row[type];
      },

      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['delayAmount'].includes(column.property)) {
              return data
                .map((i) => i['delayAmount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
            }
            return null;
          }),
        ];
      },
      getDetail(allDetail) {
        if (allDetail != null && allDetail.length > 0) {
          this.goodsData = allDetail;
          this.goodsData.map((item) => {
            item.isLockExchangeRate = item.isLockExchangeRate == '1';
            return item;
          });
        }
      },
      // 载具表格新增一行
      insertEvent() {
        this.$refs.goodsTable.validate().then(() => {
          const record = {
            id: null,
            tempId: new Date().getTime(),
            acceptanceId: this.acceptanceInfo.id,
            delayAmount: 0,
            delayExchangeRate: 0,
            delayCost: 0,
            delayDate: null,
            delayPaymentDate: null,
            branchName: null,
            bankAccountNum: null,
            businessDepartmentName: null,
            isLockExchangeRate: false,
          };
          this.goodsData.push(record);
          this.$refs.goodsTable
            .insertAt(record, -1)
            .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('acceptanceDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.forEach((item) => {
              if (item.id) {
                this.delDelayPayList.push(item.id);
              }
            });
            // 遍历承兑行 更新this.activeIndex
            selectedList.map((it) => {
              let selIndex = this.$refs[goodsTable].getRowIndex(it);
              if (this.activeIndex > selIndex) {
                this.activeIndex--;
              } else if (this.activeIndex == selIndex) {
                if (this.$refs.delayLockExchangeRateTable) {
                  this.$refs.delayLockExchangeRateTable.delayInfo = {};
                  this.$refs.delayLockExchangeRateTable.getDetail([]);
                }
              }
            });
            this.$refs[goodsTable].removeSelecteds();
            this.goodsData = this.$refs[goodsTable].getTableData().fullData;
            this.$refs[goodsTable].updateFooter();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      // 返回数据
      exportChildData() {
        return new Promise((resolve, reject) => {
          const tableForm = {};
          //押汇锁汇
          // let id = this.activeAccept.id || this.activeAccept.tempId;
          let index = null;
          if (this.activeAccept.id || this.activeAccept.tempId) {
            if (this.activeAccept.id) {
              index = this.goodsData.findIndex((it) => it.id == this.activeAccept.id);
            } else if (this.activeAccept.tempId) {
              index = this.goodsData.findIndex((it) => it.tempId == this.activeAccept.tempId);
            }
          }
          if (index != -1 && index != null && this.goodsData[index].isLockExchangeRate) {
            let res = this.exportChildDataDelayLock();
            if (res) {
              this.goodsData[index].delayLockList = res.delayLockList;
              this.goodsData[index].delDelayLockList = res.delDelayLockList;
            }
          }
          tableForm.delayPaymentList = JSON.parse(JSON.stringify(this.goodsData));
          tableForm.delayPaymentList.map((item) => {
            item.isLockExchangeRate = item.isLockExchangeRate ? '1' : '0';
            item.tenantCode = this.userInfo.tenantCode;
            item.companyCode = this.userInfo.companyCode;
            item.companyName = this.userInfo.companyName;
            item.departmentCode = this.userInfo.departmentCode;
            item.departmentName = this.userInfo.departmentName;
            item.clCode = this.baseData.clCode;
            return item;
          });
          tableForm.delDelayPayList = this.delDelayPayList;
          // 点击提交，走校验
          // if (tableForm.delayPaymentList.length == 0) {
          //   this.$message({
          //     showClose: true,
          //     message: this.$t('acceptanceDetail.msg.delyGoodsMsg'),
          //     type: 'error',
          //   });
          //   return false;
          // } else {
          this.$refs['goodsTable']
            .validate()
            .then(() => {
              resolve(tableForm);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: this.$t('acceptanceDetail.msg.delyGoodsMsg'),
                type: 'error',
              });
              reject();
            });
          // }
        });
      },

      currentChange(row) {
        //切换时保存当前值
        if (this.activeAccept) {
          // let id = this.activeAccept.id || this.activeAccept.tempId;
          let index = null;
          if (this.activeAccept.id || this.activeAccept.tempId) {
            if (this.activeAccept.id) {
              index = this.goodsData.findIndex((it) => it.id == this.activeAccept.id);
            } else if (this.activeAccept.tempId) {
              index = this.goodsData.findIndex((it) => it.tempId == this.activeAccept.tempId);
            }
          }
          //押汇锁汇
          if (index != -1 && index != null && this.goodsData[index].isLockExchangeRate) {
            this.exportChildDataDelayLock()
              .then((res) => {
                if (res) {
                  this.goodsData[index].delayLockList = res.delayLockList;
                  this.goodsData[index].delDelayLockList = res.delDelayLockList;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }

        this.activeAccept = row.row;
        this.activeIndex = row.rowIndex;
        this.$emit('currentChangeDelay', this.activeAccept);
      },
      editActived() {
        console.log('editActived');
        /* this.activeAccept = row.row;
      this.changeLock(this.activeAccept.isLockExchangeRate=="1")
      setTimeout(()=>{
        if(this.$refs.lockExchangeRateTable) this.$refs.lockExchangeRateTable.getDetail(this.activeAccept.lockExchangeRateList)
      },1000) */
      },

      activeRowMethod() {
        //禁用编辑
        return this.$route.query.isEdit == 'Y';
      },
    },
  };
</script>
<style scoped>
  .acceptBaseInfo {
    float: right;
  }
  .acceptBaseInfoItem {
    margin-right: 20px;
  }
</style>
